import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ecg-logo',
  templateUrl: './logo.component.svg'
})
export class LogoComponent implements OnInit {
  @Input() height = '100%';
  @Input() width = '100%';

  constructor() { }

  ngOnInit() {
  }

}
